module.exports = __webpack_public_path__ + "img/sy-xz.9fdb2e63.png";